module.exports = __webpack_public_path__ + "img/skypostal-logo.0eddb625.png";